import apiClient from "./client.js";

/**
 * Fetch all workspaces the authenticated user belongs to.
 * Does not require an active workspace context (no X-Workspace-Id needed).
 */
export async function fetchMyWorkspaces() {
  const response = await apiClient.get("/me/workspaces");
  return response.data.data;
}

export async function fetchMe() {
  const response = await apiClient.get("/auth/me");
  return response.data.data;
}

export async function updateMe(data) {
  const response = await apiClient.patch("/auth/me", data);
  return response.data.data;
}

export async function updateMyPassword(data) {
  await apiClient.post("/auth/me/password", data);
}

export async function startTOTPSetup() {
  const response = await apiClient.post("/auth/me/2fa/totp/setup");
  return response.data.data;
}

export async function enableTOTP(data) {
  const response = await apiClient.post("/auth/me/2fa/totp/enable", data);
  return response.data.data;
}

export async function disableTOTP(data) {
  await apiClient.post("/auth/me/2fa/totp/disable", data);
}

export async function setEmailOTP(enabled) {
  const response = await apiClient.post("/auth/me/2fa/email-otp", { enabled });
  return response.data.data;
}

export async function regenerateRecoveryCodes() {
  const response = await apiClient.post("/auth/me/2fa/recovery-codes");
  return response.data.data;
}
